import { Loader2 } from "lucide-react";
import { OrgTable, useOrgs } from "@/components/admin/AttendanceAdmin";
import PlanPrices from "@/components/admin/PlanPrices";

export default function ProjectionSubs() {
  const { orgs, onDays, dialog } = useOrgs("projection");
  return (
    <div className="space-y-10" data-testid="projection-subs">
      <PlanPrices />
      <section>
        <h3 className="font-serif-display text-2xl text-white mb-1">Organisations — Hymn Projection access</h3>
        <p className="text-xs text-neutral-500 mb-4">The gift icon grants, extends or revokes free Hymn Projection access (permanent, until a date, or for a number of days). Billing readiness for all plans is on the Attendance tab.</p>
        {orgs ? <OrgTable orgs={orgs} product="projection" onDays={onDays} /> : <Loader2 className="animate-spin text-[#D4AF37]" />}
        {dialog}
      </section>
    </div>
  );
}
